import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    AutoSaveSatusBar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem 0',
    },
    AutoSaveSatusBarText: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.light,
    },
}))
